import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { newsEntriesMarkNewsEntryAsRead } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useMarkNewsEntryAsRead = (
  options: UseMutationOptions<
    void,
    unknown,
    { id: number; revision: number },
    unknown
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (args: { id: number; revision: number }) =>
      extractData(
        newsEntriesMarkNewsEntryAsRead({
          path: {
            newsEntryId: args.id,
            newsEntryRev: args.revision,
          },
        })
      ),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['NewsEntries'],
      });
      options.onSuccess?.(...args);
    },
  });
};
